(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-product-images]').forEach((gallery) => {
      if (gallery.dataset.mbInitialized) return;
      gallery.dataset.mbInitialized = 'true';
      const slides = gallery.querySelector('[data-product-photos]');
      const counter = gallery.querySelector('[data-mb-gallery-count]');
      if (!slides || !counter) return;
      const update = () => {
        const items = Array.from(slides.querySelectorAll('.product-main-slide:not(.hide)'));
        const selected = items.findIndex((item) => item.classList.contains('is-selected'));
        counter.textContent = `${Math.max(0, selected) + 1} / ${items.length}`;
      };
      update();
      new MutationObserver(update).observe(slides, {subtree: true, attributes: true, attributeFilter: ['class']});
    });
    root.querySelectorAll('[data-mb-purchase]').forEach((bar) => {
      if (bar.dataset.mbInitialized) return;
      const section = document.getElementById(bar.dataset.productSection);
      const form = section?.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      bar.dataset.mbInitialized = 'true';
      const observer = new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
      });
      observer.observe(form);
      bar.querySelector('a').addEventListener('click', (event) => {
        event.preventDefault();
        const target = section.querySelector('.globo-swatch-product-detail, .variant-wrapper') || form;
        target.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

document.addEventListener("click", (event) => {
  const trigger = event.target.closest(".mb-size-chart [popovertarget]");
  if (!trigger) return;
  const dialog = trigger.closest(".mb-size-chart").querySelector(".mb-size-chart__dialog");
  if (dialog) trigger.setAttribute("popovertarget", dialog.id);
}, true);
